import { render, staticRenderFns } from "./companyListCard.vue?vue&type=template&id=5269e4e8&scoped=true"
import script from "./companyListCard.vue?vue&type=script&lang=js"
export * from "./companyListCard.vue?vue&type=script&lang=js"
import style0 from "./companyListCard.vue?vue&type=style&index=0&id=5269e4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269e4e8",
  null
  
)

export default component.exports